import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <div className="mb-6">
          <span className="text-6xl font-heading font-bold text-foreground-200">404</span>
        </div>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          Page Not Found
        </h1>
        <p className="text-sm text-foreground-600 mb-8 max-w-md">
          The page you are looking for does not exist or has been moved. Check the URL or return to the homepage.
        </p>
        <button
          onClick={() => navigate('/')}
          className="btn-primary"
        >
          Back to Homepage
        </button>
      </div>
    </div>
  );
}